import React from "react"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import MaturityBadge from "views/atoms/badges/MaturityBadge"

const ChartSDG13WebsiteMaturityKpiMolecule = ({ value, translationKey }) => {
  const { t } = useTranslation()

  const hasValue = value != null

  const content = {
    kpi: hasValue ? value : "-",
    kpi_unit: hasValue ? "%" : "",
    kpi_text: t(`${translationKey}.title`),
    reference: <MaturityBadge value={hasValue ? value : null} />,
  }

  return (
    <HelpWidgetChartInteractiveMolecule text={t(`${translationKey}.help`)}>
      <TextChart content={<TextChartMinor content={content} />} />
    </HelpWidgetChartInteractiveMolecule>
  )
}

ChartSDG13WebsiteMaturityKpiMolecule.propTypes = {
  value: PropTypes.number,
  translationKey: PropTypes.string.isRequired,
}

export default ChartSDG13WebsiteMaturityKpiMolecule
